import { useAuth } from '@pasqal/core/hooks/useAuth';
import { Footer } from '@pasqal/core/ui/apps/Footer';
import { Header } from '@pasqal/core/ui/apps/Header';
import { Heading } from '@pasqal/core/ui/components/typography/Text';
import screenshotImg1 from '~/assets/images/ps-screenshot-1.png';
import screenshotImg2 from '~/assets/images/ps-screenshot-2.png';
import EditorButton from '~/components/editor/EditorButton/EditorButton';
import './HomePage.css';

export default function HomePage() {
  const { goToLoginPage } = useAuth();

  return (
    <div className="HomePage">
      <Header appName="Pulser Studio" />
      <div className="HomePage-contentRow">
        <div className="HomePage-left">
          <Heading as="h1" className="HomePage-description" variant="heading1">
            Pulser Studio, a no-code development platform for neutral atom
            quantum computing.
          </Heading>
          <EditorButton
            kind="primary"
            className="HomePage-loginButton"
            onClick={() => goToLoginPage('/experiment')}
          >
            Get started
          </EditorButton>
        </div>
        <div className="HomePage-right">
          <img src={screenshotImg1} alt="Pulser Studio 1" />
          <img src={screenshotImg2} alt="Pulser Studio 2" />
        </div>
      </div>
      <Footer />
    </div>
  );
}
